export const policyDocumentTypeLabels: Record<string, string> = {
  DEC: "Declarations Page",
  DISC: "Disclosure",
  C1: "Cancellation - Non-Payment",
  C2: "Cancellation - Returned Check",
  C3: "Cancellation - Underwriting",
  NR: "Non-Renewal",
  CR: "Conditioned Renewal",
  CRP: "Conditioned Renewal",
  REIN: "Reinstatement",
  TERM: "Termination",
};

export function formatPolicyDocumentType(type: string): string {
  return policyDocumentTypeLabels[type] || type;
}
